import * as era from '!/era'
import { ui } from '!/skin'
import { Skeleton } from '@/ui/components/Skeleton'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import * as moviesModel from './model'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t='movies' />
}

const skin = era.skin('routes/movies/root')

MoviesPage.displayName = 'MoviesPage'
export function MoviesPage(): JSX.Element {
  const isContentLoading = useUnit(moviesModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='main' isLoading={isContentLoading}>
          <ui.RenderSkin name='bannersTypeVod' />
          <ui.RenderSkin name='featuredCarouselTypeVod' />
          <ui.RenderSkin name='bundlesMovies' />
          <ui.RenderSkin name='movieCategories' />
          <ui.RenderSkin name='infiniteCategory' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
